/* eslint-disable no-else-return */
import { ApolloClient, InMemoryCache, ApolloLink, HttpLink } from '@apollo/client';
import getConfig from 'next/config';
import { setCookie, removeCookie } from '../src/hooks/useCookie';

const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

let url;
if (typeof window !== 'undefined') {
  url = publicRuntimeConfig.NEXT_PUBLIC_GRAPHQL
    ? `${publicRuntimeConfig.NEXT_PUBLIC_GRAPHQL}/graphql/`
    : '/graphql/';
} else {
  url = `${serverRuntimeConfig.API_GATEWAY_SERVER}/graphql/`;
}

const httpLink = new HttpLink({ uri: url });
const loggerLink = new ApolloLink((operation, forward) => {
  // Add application source header to all server side requests
  if (typeof window !== 'undefined') {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'x-application-source': 'online-acquisition-ui',
      },
    }));
  }
  // console.log(`Starting request for ${operation?.variables?.cartType}`);
  if (
    operation?.variables?.cartType === 'CROSS_SELL' ||
    operation?.variables?.cartType === 'CHANGE_OFFER'
  ) {
    if (operation?.variables?.token === '' && typeof window !== 'undefined') {
      setCookie('ION', 'token-missing', true);
      // window.location.reload();
      return operation?.variables?.cartType;
    } else {
      removeCookie('token-missing');
      return forward(operation).map(response => {
        if (response?.errors !== undefined) {
          console.log(
            `Error ${operation.operationName}`,
            response?.errors[0].message,
            response?.errors[0].message.search('403')
          );
          if (response?.errors[0].message.search('403') >= 0) {
            // localStorage.setItem('found-403', true);
            setCookie('ION', 'found-403', true);
            // window.location.reload();
          }
        }
        // localStorage.setItem('found-403', true);
        // console.log(`Received response for ${operation.operationName}`, response);
        return response;
      });
    }
  } else {
    return forward(operation).map(response => response);
  }
});

const client = new ApolloClient({
  link: ApolloLink.from([loggerLink, httpLink]),
  uri: url,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
    },
  },
});

export default client;
